import usePortfolio from "src/use/portfolio";

const {
  portfolio,

  portfoliostock,
  getPortfolioTransactions,
  postPortfolioTransaction,

  updateportfoliostock,
  deleteportfoliostock,

  portfolioDemat,
  postPortfolioDemat,
  updatePortfolioDemat,
  deletePortfolioDemat,

  portfolioFixedBank,
  postPortfolioFixedBank,
  updatePortfolioFixedBank,
  deletePortfolioFixedBank,

  portfolioSavingBank,
  postPortfolioSavingBank,
  updatePortfolioSavingBank,
  deletePortfolioSavingBank,

  portfolioLoan,
  postPortfolioLoan,
  updatePortfolioLoan,
  deletePortfolioLoan,

  commodity,
  postcommodity,
  updatecommodity,
  deletecommodity,

  realEstate,
  postrealEstate,
  updaterealEstate,
  deleterealEstate,

  allBankList,
} = usePortfolio();

export function onLoadBankList({ commit }) {
  return new Promise((resolve, reject) => {
    allBankList()
      .then((res) => {
        commit("updateBankList", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function myPortfolio({ commit }) {
  return new Promise((resolve, reject) => {
    portfolio()
      .then((res) => {
        commit("updatePortfolio", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onLoadPortfolioStock({ commit }) {
  return new Promise((resolve, reject) => {
    portfoliostock()
      .then((res) => {
        commit("updatePortfolioStock", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}
export function onLoadPortfolioTransaction({ commit }) {
  return new Promise((resolve, reject) => {
    getPortfolioTransactions()
      .then((res) => {
        commit("updatePortfolioTransactions", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onpostPortfolioTransaction(context, postStock) {
  postPortfolioTransaction(postStock);
}
export function onUpdatePortfolioStock(context, updateStock) {
  updateportfoliostock(updateStock);
}
export function onDeletePortfolioStock(context, deleteStock) {
  deleteportfoliostock(deleteStock);
}

export function onLoadPortfolioDemat({ commit }) {
  return new Promise((resolve, reject) => {
    portfolioDemat()
      .then((res) => {
        commit("updatePortfolioDemat", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}
export function onPostPortfolioDemat(context, postDemat) {
  postPortfolioDemat(postDemat);
}
export function onUpdatePortfolioDemat(context, updateDemat) {
  updatePortfolioDemat(updateDemat);
}
export function onDeletePortfolioDemat(context, deleteDemat) {
  deletePortfolioDemat(deleteDemat);
}

export function onLoadPortfolioFixedBank({ commit }) {
  return new Promise((resolve, reject) => {
    portfolioFixedBank()
      .then((res) => {
        commit("updatePortfolioFixedBank", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onPostPortfolioFixedBank(context, postFixed) {
  postPortfolioFixedBank(postFixed);
}
export function onUpdatePortfolioFixedBank(context, updateFixed) {
  updatePortfolioFixedBank(updateFixed);
}
export function onDeletePortfolioFixedBank(context, deleteFixed) {
  deletePortfolioFixedBank(deleteFixed);
}

export function onLoadPortfolioSavingBank({ commit }) {
  return new Promise((resolve, reject) => {
    portfolioSavingBank()
      .then((res) => {
        commit("updatePortfolioSavingBank", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}
export function onPostPortfolioSavingBank(context, postSaving) {
  postPortfolioSavingBank(postSaving);
}
export function onUpdatePortfolioSavingBank(context, updateSaving) {
  updatePortfolioSavingBank(updateSaving);
}
export function onDeletePortfolioSavingBank(context, deleteSaving) {
  deletePortfolioSavingBank(deleteSaving);
}

export function onLoadPortfolioLoan({ commit }) {
  return new Promise((resolve, reject) => {
    portfolioLoan()
      .then((res) => {
        commit("updatePortfolioLoan", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onPostPortfolioLoan(context, postLoan) {
  postPortfolioLoan(postLoan);
}
export function onUpdatePortfolioLoan(context, updateLoan) {
  updatePortfolioLoan(updateLoan);
}
export function onDeletePortfolioLoan(context, deleteLoan) {
  deletePortfolioLoan(deleteLoan);
}

export function onLoadcommodity({ commit }) {
  return new Promise((resolve, reject) => {
    commodity()
      .then((res) => {
        commit("updatecommodity", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onPostcommodity(context, postCommodity) {
  postcommodity(postCommodity);
}
export function onUpdatecommodity(context, updateCommodity) {
  updatecommodity(updateCommodity);
}
export function onDeletecommodity(context, deleteCommodity) {
  deletecommodity(deleteCommodity);
}

export function onLoadrealEstate({ commit }) {
  return new Promise((resolve, reject) => {
    realEstate()
      .then((res) => {
        commit("updaterealEstate", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export function onPostrealEstate(context, postrealEstatedata) {
  postrealEstate(postrealEstatedata);
}
export function onUpdaterealEstate(context, updaterealEstatedata) {
  updaterealEstate(updaterealEstatedata);
}
export function onDeleterealEstate(context, deleterealEstatedata) {
  deleterealEstate(deleterealEstatedata);
}
